import { queryClient } from "@impero-com/common/utils/query_client";
import { queryOptions, useQuery } from "@tanstack/react-query";

import { PostRisksRiskDirectoryIdAiInsightsParams } from "api/generated/model";
import { postRisksRiskDirectoryIdAiInsights } from "api/generated/risks/risks";

const COMPARE_RISK_MAP_QUERY_KEY = "compare-risk-map";

export type { RiskMapKind } from "api/generated/model";

export interface CompareRiskMapQueryParams extends PostRisksRiskDirectoryIdAiInsightsParams {
    riskDirectoryId: number;
}

export function getCompareRiskMapQueryKey(params: CompareRiskMapQueryParams) {
    return [
        COMPARE_RISK_MAP_QUERY_KEY,
        params.riskDirectoryId,
        params.kind,
        params.from,
        params.to,
    ];
}

function compareRiskMapQueryOptions(params: CompareRiskMapQueryParams) {
    return queryOptions({
        queryKey: getCompareRiskMapQueryKey(params),
        queryFn: () =>
            postRisksRiskDirectoryIdAiInsights(params.riskDirectoryId, {
                kind: params.kind,
                from: params.from,
                to: params.to,
            }),
        staleTime: Infinity,
    });
}

export function prefetchCompareRiskMap(params: CompareRiskMapQueryParams) {
    return queryClient.prefetchQuery(compareRiskMapQueryOptions(params));
}

export function useCompareRiskMapQuery(
    params: CompareRiskMapQueryParams,
    enabled?: boolean
) {
    const isEnabled = enabled && Object.values(params).every(Boolean);

    return useQuery({
        ...compareRiskMapQueryOptions(params),
        select: (response) => response.data,
        enabled: isEnabled,
    });
}
